module.exports = __webpack_public_path__ + "img/warning_temp.6e6ed876.svg";